import { render } from "./DashboardWrapper.vue?vue&type=template&id=b7ea1d8c"
import script from "./DashboardWrapper.vue?vue&type=script&lang=js"
export * from "./DashboardWrapper.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/DashboardWrapper.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b7ea1d8c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b7ea1d8c', __exports__)) {
    api.reload('b7ea1d8c', __exports__)
  }
  
  module.hot.accept("./DashboardWrapper.vue?vue&type=template&id=b7ea1d8c", () => {
    api.rerender('b7ea1d8c', render)
  })

}


export default __exports__